import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { HUB_ENVS, type HubEnv } from './types';

interface EnvState {
  env: HubEnv;
  setEnv: (env: HubEnv) => void;
}

function isHubEnv(value: string): value is HubEnv {
  return (HUB_ENVS as readonly string[]).includes(value);
}

export const useEnvStore = create<EnvState>()(
  persist(
    (set) => ({
      env: 'dev',
      setEnv: (env) => set({ env }),
    }),
    {
      name: 'hub.env',
      version: 1,
      migrate: (state, _version) => {
        if (state && typeof state === 'object' && 'env' in state) {
          const candidate = (state as { env?: unknown }).env;
          if (typeof candidate === 'string' && isHubEnv(candidate)) {
            return state as EnvState;
          }
        }
        return { env: 'dev', setEnv: () => undefined };
      },
    },
  ),
);
